import { useState } from 'react'
import PropTypes from 'prop-types'
import useMeasure from 'react-use-measure'
import { useChain, useSpring, useSpringRef, animated } from 'react-spring'

export const Expand = ({
  classNameLayout,
  show,
  children,
  direction = 'vertical',
  chain = false,
  width = 'fit-content',
  extraStyle = {},
  ...rest
}) => {
  const [ref, dimensions] = useMeasure()
  const [initialShow] = useState(show)
  const [heightRested, setHeightRested] = useState(false)
  const dimension = direction === 'vertical' ? 'height' : 'width'
  const animateExpand = useSpringRef()
  const animateOpacity = useSpringRef()
  const targetSize = dimensions[dimension]

  const expandStyle = useSpring({
    ref: chain ? animateExpand : null,
    [dimension]: show ? targetSize : 0,
    onRest: () => setHeightRested(true)
  })
  const opacityStyle = useSpring({
    ref: chain ? animateOpacity : null,
    opacity: show ? 1 : 0
  })

  if (chain) {
    const animation = [animateExpand, animateOpacity]
    useChain(show ? animation : animation.reverse())
  }

  const style = initialShow && !heightRested
    ? {}
    : {
        overflow: 'hidden',
        ...expandStyle,
        ...opacityStyle,
        ...extraStyle
      }

  return (
    <animated.div
      aria-hidden={!show}
      {...rest}
      style={style}
    >
      <div className={classNameLayout} style={{ width }} ref={ref}>
        {children}
      </div>
    </animated.div>
  )
}

Expand.propTypes = {
  show: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf([
    'vertical',
    'horizontal'
  ]),
  className: PropTypes.string
}

export default Expand
